


































import { Component, Vue, Prop } from 'vue-property-decorator';
import PageFooter from '@/pdf/components/PageFooter.vue';
import SustainabilityCompass from '@/charts/SustainabilityCompass.vue';

@Component ({
  components: {
    PageFooter,
    SustainabilityCompass },
})
export default class CompanySustainability extends Vue {
  @Prop() readonly doc!: any;

  title(group: string): string {
    switch (group) {
      case '40':
        return 'Varor & material';
      case '46':
        return 'Underentreprenörer';
      case '50':
        return 'Lokaler';
      case '51':
        return 'Fastighetskostnader';
      case '52':
        return 'Hyra av anläggningstillgångar';
      case '53':
        return 'Energi';
      case '54':
        return 'Förbrukningsmaterial';
      case '55':
        return 'Reparation & underhåll';
      case '56':
        return 'Transportmedel';
      case '57':
        return 'Frakter & transport';
      case '58':
        return 'Resor';
      case '59':
        return 'Reklam & PR';
      case '60':
        return 'Övriga försäljningskostnader';
      case '61':
        return 'Kontorsmaterial';
      case '62':
        return 'Tele & post';
      case '63':
        return 'Försäkringar & riskhantering';
      case '64':
        return 'Förvaltning';
      case '65':
        return 'Övriga externa tjänster';
      case '68':
        return 'Inhyrd personal';
      case '69':
        return 'Övriga externa kostnader';
      case '70':
        return 'Medarbetare';
      case '74':
        return 'Pensioner';
      case '75':
        return 'Skatter';
    }
    return '';
  }

  account(group: string): string {
    switch (group) {
      case '40':
        return '40-45, 47, 49';
      case '70':
        return '70-73, 76';
      case '75':
        return '75, 89';
    }
    return group;
  }

}

